/* eslint-disable react/no-array-index-key */

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { useHistory } from 'react-router';
import { Box, Flex } from 'UIKit/Grid';
import { FormError, FormSuccess } from 'UIKit/Fonts';
import { SagnificantText } from 'UIKit/Form';
import {
  fetchList,
  fetchParticipation,
  // headers,
  REQUEST_OLIMPIC_LIST,
  fetchSaveOlimpicResult,
  REQUEST_SAVE_OLIMPIC_RESULT,
  fetchOlimpicStageData,
} from '@/modules/Olimpic';
import Gamification from '@/components/Gamification';
// import { uniqueId } from '@/utils/Helpers';
import { formatNumWithCommas } from '@/utils/Helpers';

import { useOlimpicState, useOlimpicActions } from '@/pages/olimpic/context';
import Loading from '@/components/Form/Loading';
import VirtualAbacus from '@/styledComponents/render/simulators/VirtualAbacus';

import UamapBG from '@/assets/img/UamapBG.jpg';

import Timer from '@/components/Timer';
import Panel from '@/components/Panel';
import { cleaRequest } from '../../modules/Requests';

const size = 10;
// const multidivSize = 20;

const HideOnPrint = styled.div`
  @media print {
    display: none;
  }
`;

const useStyles = props =>
  makeStyles(theme => ({
    root: {
      padding: '24px 0px',
      flexWrap: 'wrap',
      '& > div': {
        marginBottom: theme.spacing(1),
      },
    },
    button: {
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    completed: {
      display: 'inline-block',
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      textAlign: 'center',
    },
    table: {
      margin: '10px 0px',
      '@media print': {
        margin: '1.5px !important',
      },
    },
    body: {
      fontFamily: props.certificationType === 'sama' ? 'Pama' : '',
      fontSize: 14,
      textAlign: 'center',
    },
    head: {
      backgroundColor:
        props.certificationType === 'sama' ? '#b7e8fa' : '#30BEEF',
      color: '#000',
      fontWeight: 'bold',
      textAlign: 'center',
      border: 'none',
    },
    first: {
      color: '#000',
      fontWeight: 'bold',
      textAlign: 'center',
    },
    footer: {
      fontWeight: 'bold',
      color: '#000',
      backgroundColor:
        props.certificationType === 'sama' ? '#b7e8fa' : '#30BEEF',
      textAlign: 'center',
      border: 'none',
      '& > div': {
        gap: 5,
      },
    },
    h6: {
      fontSize: '14px',
      color: '#252733',
      marginTop: '42px',
    },
    answer: {
      border: '1px solid #A5D1E1',
      fontSize: '16px',
      fontWeight: 'normal',
      padding: '6px 0',
      width: '100%',
      fontFamily: '"Montserrat", sans-serif',
      textAlign: 'center',
    },
  }));

const WrapperStyled = styled.div`
  z-index: 10;

  @media print {
    position: absolute;
  }

  &&& {
    .MuiButtonBase-root {
      &:hover {
        background: #daf5ff;
        border: 0;
        box-shadow: none;
        text-shadow: none;
      }
    }
    .MuiStep-horizontal .MuiButtonBase-root {
      &:hover {
        background: none;
        cursor: default;
      }
    }
    .MuiStepIcon-root.MuiStepIcon-active {
      fill: ${props => (props.type === 'sama' ? '#b7e8fa' : '#292E88')};
      width: 30px;
      height: 30px;
      border: 0;
      .MuiStepIcon-text {
        fill: ${props => (props.type === 'sama' ? '#252733' : '#ffffff')};
      }
    }
    .MuiStepLabel-label {
      font-family: 'Montserrat', sans-serif;
      &.MuiStepLabel-active {
        color: #252733;
        font-weight: bold;
      }
    }
    .MuiStepConnector-line {
      border-color: rgba(0, 0, 0, 0.5);
      margin: 0 20px;
    }
    .MuiStepIcon-root {
      width: 30px;
      height: 30px;
      fill: #fff;
      border: 1px solid rgba(0, 0, 0, 0.5);
      border-radius: 30px;
      .MuiStepIcon-text {
        fill: rgba(0, 0, 0, 0.5);
      }
    }
    .MuiButton-containedPrimary {
      color: ${props => (props.type === 'sama' ? '#252733' : '#ffffff')};
      background-color: ${props =>
        props.type === 'sama' ? '#b7e8fa' : '#292E88'};
      box-shadow: none;
      border-radius: 100px;
      font-size: 14px;
      padding-left: 38px;
      padding-right: 38px;
      padding-top: 10px;
      padding-bottom: 7px;
      text-transform: none;
      text-decoration: none;
      &:hover {
        background-color: ${props =>
          props.type === 'sama' ? '#b7e8fa' : '#292E88'};
      }
      &.Mui-disabled {
        color: rgba(0, 0, 0, 0.5);
        background-color: #e0e0e0;
      }
    }
    .MuiInput-underline {
      &:before {
        border-bottom: 0;
      }
    }
    .MuiInput-underline {
      &:after {
        border-bottom: 0;
      }
    }
  }

  & .olimpic_timer {
    position: fixed;
    z-index: 100;
    left: 50%;
    background: white;
    padding: 10px;
    border-radius: 5px;
    margin: 0;
    transform: translateY(-40px);
  }
`;

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: '#b7e8fa',
    color: '#000',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  footer: {
    fontWeight: 'bold',
    color: '#000',
    backgroundColor: '#b7e8fa',
  },
  first: {
    color: '#000',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  body: {
    fontSize: 14,
  },
  root: {
    borderBottom: 'none',
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const StyledTable = styled(Table)`
  border-collapse: collapse;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  overflow: hidden;
  td, th {
    border: 1px solid #E9E9E9;
  }
  tr:first-child td {
    border-top: 0;
  }
  tr td:first-child {
    border-left: 0;
  }
  tr:last-child td {
    border-bottom: 0;
  }
  tr td:last-child {
    border-right: 0;
  }
  
  & .MuiInput-input {
    font-size: 22px;
    height: 20px;
    min-width: 30px;
    text-align: center;
    font-family: Kaufmann, sans-serif;
  }
  & .MuiTableCell-alignLeft {
    text-align: left !important;
  }
  & .MuiTableCell-alignRight {
    text-align: right !important;
  }
  & .MuiTableCell-root {
    font-family: "Kaufmann", serif;
    vertical-align: middle;
    line-height: 26px;
    font-size: 26px;
    padding: 5px;
    &[check="true"] {
      &[valid="false"] {
        .MuiInput-input {
          color: #FF3333;
          background: #FFEFEF;
          height: max-content;
        }
      }
      &[valid="true"] {
        .MuiInput-input {
          color: #48B820;
          background: #F0FFEF;
        }
      }
    }
  }

  @media print {
  /* Настройки вида печати */
  @page {
    margin: 0.2in;
  }

  .button, .instructions, iframe, .olimpic_timer {
    display: none !important;
  }

  /* Таблица с примерами*/
  & .MuiTableCell-root {
    font-weight: bold !important;
    padding: 1px 5px !important;
    line-height: 0.9 !important;
    min-height: 0 !important;
    height: auto !important;
    white-space: nowrap !important;
    border: none !important;
    font-size: 20px !important; /* сохраняем исходный размер */
  }

  & {
    // box-shadow: none !important;
    border-radius: 0 !important;
    overflow: visible !important;
  }

  tr {
    height: auto !important;
  }
}

  & tr{
      &:nth-child(${props => props.focusedRow}) {
        background: #F1FAFE;
      }
      &:not(:last-child) {
        td {
          &:nth-child(${props => props.focusedCol}) {
            background: #F1FAFE;
            &[scope="withBg"] {
              background: ${props =>
                props.type === 'sama' ? '#A5D3E3' : '#2FBCEE'};
            }
          }
        }
      }
    }
  }
`;

const StyledPanel = styled(Panel)`
  @media print {
    ${props =>
      props.$hideInPrintAll &&
      css`
        display: none !important;
      `}

    background: transparent !important;
    padding: 0 !important;
    .pama-print-block {
      margin-top: 1px !important;
    }

    /* CТИЛИ ДЛЯ PAMA - именно на листе печати*/
    ${props =>
      props.$smgl &&
      css`
        .MuiTableCell-root {
          padding: 4px 1px !important;
          // line-height: 1.1 !important;
        }
        /* Уменьшаем padding ТОЛЬКО для tie-break multiplication/division */
        .pama-tiebreak-math .MuiTableCell-root {
          padding: 1px 1px !important;
        }

        .pama-tiebreak-math {
          padding-left: 15px !important;
        }

        /* Flex-контейнер: всё в одну строку, занимает всю ширину ячейки */
        .pama-tiebreak-math .olimpic-answer-cell > div {
          display: flex !important;
          flex-wrap: nowrap !important;
          align-items: center !important;
          width: 100% !important;
          gap: 3px !important;
        }

        /* TextField РАСТЯГИВАЕТСЯ на всё свободное место */
        .pama-tiebreak-math .olimpic-answer-cell .MuiInput-root {
          flex: 1 1 auto !important;
          min-width: 25px !important;
          width: auto !important;
          max-width: none !important;
        }

        .pama-tiebreak-math .olimpic-answer-cell .MuiInput-input {
          width: 100% !important;
          min-width: 0 !important;
          font-size: 14px !important;
        }

        /* Ответ занимает ТОЛЬКО столько, сколько нужно тексту */
        .pama-tiebreak-math .olimpic-answer-cell .olimpic-answer-value {
          flex: 0 0 auto !important;
          width: auto !important;
          white-space: nowrap !important;
          padding: 0 3px !important;
          font-size: 11px !important;
          line-height: 1 !important;
        }

        /* Блоки умн-дел кроме tie */
        .pama-print-math td:nth-child(2) span {
          margin-left: 10px !important;
        }
      `}
  }
  ${props =>
    props.$smgl &&
    props.$view === 'print' &&
    css`
      padding: 0 !important;
    `}
`;

const IcoWrap = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: none;
  z-index: 0;

  @media print {
    display: flex;
  }
`;

// Функция для определения названия этапа в ШАПКЕ PamaPrint
const getPamaPrintTitle = activeData => {
  if (activeData.type === 'Mix') {
    return 'Abacus Tie-breaker';
  }
  if (activeData.variant === 'ABACUS') {
    return 'Abacus Calculation';
  }
  if (activeData.variant === 'MENTAL') {
    return 'Mental Calculation';
  }
  return '';
};

const StageHeader = ({ stageInfo, settings, smgl, view, compact = false }) => (
  /* eslint-disable no-nested-ternary */
  <SagnificantText>
    {smgl && view === 'print' ? (
      // PAMA: шапка у этапов при печати
      <span translate="no">
        {getPamaPrintTitle(stageInfo)} Group : {settings.name}
        {'  '}
        Time : {stageInfo.time} min{' '}
        {stageInfo.type === 'Mix' ? (
          <>10 marks (+-) / 5 marks (x÷)</>
        ) : (
          <>Each Q : {stageInfo.score || 10} marks</>
        )}
      </span>
    ) : compact ? (
      // КОМПАКТНАЯ версия для листа ответов
      <span>
        <span>
          <FormattedMessage
            id={`${stageInfo.type}${stageInfo.variant || ''}`}
          />
        </span>{' '}
        <span className="notranslate">{stageInfo.short}</span>
        <span>, </span>
        <span>
          <FormattedMessage id="TIME" defaultMessage="time" />
        </span>
        <span>: </span> <span>{stageInfo.time}</span>{' '}
        <span>
          <FormattedMessage id="min" defaultMessage="min" />
        </span>
        <span>, </span>
        <span>
          <FormattedMessage id="EACH_Q" defaultMessage="Each q" />
        </span>
        <span>: </span>
        <span>{stageInfo.score}</span>{' '}
        <span>
          <FormattedMessage id="marks" defaultMessage="marks" />
        </span>
      </span>
    ) : (
      // olimp type = online
      <span>
        <span>
          <FormattedMessage id="CATEGORY" defaultMessage="Category" />
        </span>
        <span>: </span>
        <span>{settings.name}</span>
        <span>, </span>
        {!smgl && (
          <span>
            <span>
              <FormattedMessage
                id={`${stageInfo.type}${stageInfo.variant || ''}`}
              />
            </span>{' '}
            <span className="notranslate">{stageInfo.short}</span>
            <span>, </span>
          </span>
        )}
        <span>{stageInfo.samples}</span>{' '}
        <span>
          <FormattedMessage
            id="OLIMPIC_SAMPLES_TITLE"
            defaultMessage="samples"
          />
        </span>
        <span>, </span>
        <span>
          <FormattedMessage id="TIME" defaultMessage="time" />
        </span>
        <span>: </span>
        <span>{stageInfo.time}</span>{' '}
        <span>
          <FormattedMessage id="min" defaultMessage="min" />
        </span>
        <span>, </span>
        <span>
          <FormattedMessage id="EACH_Q" defaultMessage="Each q" />
        </span>
        <span>: </span>
        <span>{stageInfo.score}</span>{' '}
        <span>
          <FormattedMessage id="marks" defaultMessage="marks" />
        </span>
      </span>
    )}
  </SagnificantText>
);

StageHeader.propTypes = {
  stageInfo: PropTypes.shape({
    type: PropTypes.string,
    variant: PropTypes.string,
    short: PropTypes.string,
    samples: PropTypes.number,
    time: PropTypes.number,
    score: PropTypes.number,
  }).isRequired,
  settings: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  smgl: PropTypes.bool,
  view: PropTypes.string,
  compact: PropTypes.bool,
};

StageHeader.defaultProps = {
  smgl: false,
  view: undefined,
  compact: false,
};
const CenterIcon = () => {
  // Показываем водяной знак ТОЛЬКО в production
  if (process.env.NODE_ENV === 'development') {
    return null;
  }
  return (
    <IcoWrap>
      <img src={UamapBG} alt="" style={{ margin: 'auto', width: 400 }} />
    </IcoWrap>
  );
};

function formatMathSample(item, type) {
  if (Array.isArray(item)) {
    if (item.length === 1 && typeof item[0] === 'string') {
      return item[0];
    }
    if (item.length >= 2) {
      const [a, b] = item;
      if (type === 'multiplication') {
        return `${formatNumWithCommas(a)} \u2A2F ${formatNumWithCommas(b)}`;
      }
      if (type === 'division') {
        return `${formatNumWithCommas(a)} ÷ ${formatNumWithCommas(b)}`;
      }
    }
  }
  return JSON.stringify(item);
}

const calculate = (args, type, state, dataIndex, sampleIndex, direct) => {
  let left = 0;
  let right = 0;
  if (
    type === 'sum' ||
    (type === 'sumCrosswise' && ['col', 'row'].includes(direct))
  ) {
    left = state[dataIndex] && state[dataIndex][`${direct}_${sampleIndex}`];
    right = args.reduce(
      (acc, next) => acc + Number(String(next).replace(',', '')),
      0
    );
  }

  if (type === 'sumCrosswise' && direct === 'angle') {
    left = state[dataIndex] && state[dataIndex][direct];
    right = args.reduce((acc, numbers) => {
      let total = acc;
      const sum = numbers.reduce(
        (acc1, next) => acc1 + Number(String(next).replace(',', '')),
        0
      );
      total += sum;
      return total;
    }, 0);
  }

  if (type === 'multiplication') {
    left = state[dataIndex] && state[dataIndex][`${direct}_${sampleIndex}`];

    if (args.length !== 1) {
      // примеры из генератора
      right = args[0] * args[1];
    } else {
      // примеры старые из MySQL
      // TODO временно из-за данных в базе , могу содержать в х (рус) и x (латин)
      const re = /,|\$/g;
      const split = args[0].split(/х|x|\*/);
      right =
        String(split[0]).replace(re, '') * String(split[1]).replace(re, '');
    }
  }

  if (type === 'division') {
    left = state[dataIndex] && state[dataIndex][`${direct}_${sampleIndex}`];

    if (args.length !== 1) {
      // примеры из генератора
      right = args[0] / args[1];
      // [numerator, denominator] = args;
    } else {
      // примеры старые из MySQL
      // TODO некоторые примеры содержать левые символы $329.67 ÷· 89.1
      const re = /·/;
      const split = String(args[0])
        .replace(re, '')
        .split(/÷|\//);
      const reReplace = /,|\$/g;
      right =
        String(split[0]).replace(reReplace, '') /
        String(split[1]).replace(reReplace, '');
    }
  }

  if (type === 'five') {
    left = state[dataIndex] && state[dataIndex][`${direct}_${sampleIndex}`];
    right = args.reduce(
      (acc, next) => acc - Number(String(next).replace(',', '')),
      5
    );
  }

  if (type === 'ten') {
    left = state[dataIndex] && state[dataIndex][`${direct}_${sampleIndex}`];
    right = args.reduce(
      (acc, next) => acc - Number(String(next).replace(',', '')),
      10
    );
  }

  if (type === 'card') {
    left = state[dataIndex] && state[dataIndex][`${direct}_${sampleIndex}`];
    [right] = args;
  }

  return [left, right];
};

const equalfn = (args, type, state, dataIndex, sampleIndex, direct) => {
  const [left, right] = calculate(
    args,
    type,
    state,
    dataIndex,
    sampleIndex,
    direct
  );
  let equal = false;

  if ((left || +left === 0) && (right || +right === 0)) {
    equal =
      +String(left).replace(',', '.') ===
      +(Math.round(right * 100) / 100).toFixed(2);
  }

  return equal;
};

const getAnswer = (args, type, state, dataIndex, sampleIndex, direct) => {
  const [, right] = calculate(
    args,
    type,
    state,
    dataIndex,
    sampleIndex,
    direct
  );

  return (Math.round(right * 100) / 100).toFixed(2);
};

const validate = ({
  dataIndex,
  sampleIndex,
  state,
  args,
  params,
  direct,
  check,
}) => {
  const success = equalfn(
    args,
    params.type,
    state,
    dataIndex,
    sampleIndex,
    direct
  );
  return check && success ? 'true' : 'false';
};

/**
 * Заполняет состояние абака единицами согласно
 * переданному числу
 * @param {number} number - число которое нужно набрать на абаке
 * @param {number} range - это порядок абака
 * @return {object} состояние абакуса
 */
export const fillingValues = (number, range) => {
  let nextAbacus = {};
  const labels = ['a', 'b', 'c', 'd', 'e', 'f'];
  for (let i = 0; i < range; i += 1) {
    nextAbacus = { ...nextAbacus, [labels[i]]: [0, 0, 0, 0, 0] };
  }
  if (number) {
    let k = range;
    let pod = [0, 0, 0, 0, 0];
    const numberComposition = number.toString();

    const podMap = {
      '1': [0, 1, 0, 0, 0],
      '2': [0, 1, 1, 0, 0],
      '3': [0, 1, 1, 1, 0],
      '4': [0, 1, 1, 1, 1],
      '5': [1, 0, 0, 0, 0],
      '6': [1, 1, 0, 0, 0],
      '7': [1, 1, 1, 0, 0],
      '8': [1, 1, 1, 1, 0],
      '9': [1, 1, 1, 1, 1],
    };

    for (let i = numberComposition.length - 1; i >= 0; i -= 1) {
      k -= 1;
      pod = podMap[numberComposition[i]] || [0, 0, 0, 0, 0];
      nextAbacus = { ...nextAbacus, [labels[k]]: pod };
    }
  }
  return nextAbacus;
};

const getRowData = (data, index) =>
  data.reduce((acc, item) => {
    acc.push(item[index]);
    return acc;
  }, []);

const handleEnter = event => {
  if (event.keyCode === 13) {
    const inputs = document.querySelectorAll('input[type="text');
    const ind = [].indexOf.call(inputs, event.target);
    const next = inputs[ind + 1];
    if (next) {
      event.preventDefault();
      next.focus();
    }
  }
};

const TableSum = ({
  data,
  index,
  state,
  onChange,
  check,
  certificationType,
  offset,
}) => {
  const classes = useStyles({ certificationType })();
  const [focusedCol, setFocusedCol] = useState();
  const onFocus = (num, e) => {
    if (e) {
      e.preventDefault();
      const els = [];
      let a = e.target;
      while (a) {
        els.unshift(a);
        a = a.parentNode;
        if (a.tagName.toLowerCase() === 'table') {
          break;
        }
      }
      document
        .querySelectorAll('.simplebar-content-wrapper')[1]
        .scroll(0, a.offsetTop);
    }
    setFocusedCol(num + 2);
  };
  const onBlur = () => {
    setFocusedCol(0);
  };

  return (
    <StyledTable
      className={classes.table}
      focusedCol={focusedCol}
      type={certificationType}
      onKeyDown={handleEnter}
    >
      <TableHead>
        <TableRow>
          <TableCell
            className={clsx(classes.head, 'olimpic-number-cell')}
            align="left"
          >
            №
          </TableCell>
          {data.data.map((sample, keyHead) => (
            <TableCell
              className={clsx(classes.head, 'olimpic-number-cell')}
              align="center"
            >
              {offset !== undefined
                ? offset + (keyHead + 1)
                : size * index + (keyHead + 1)}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {data.data[0].map((n, keyNumber) => (
          <TableRow key={`${keyNumber}`}>
            <TableCell className={classes.first}>{keyNumber + 1}</TableCell>
            {data.data.map((s, keySample) => (
              <TableCell
                className={classes.body}
                key={`${keySample}`}
                align="right"
                style={{ padding: '5px 15px' }}
              >
                {data.data[keySample][keyNumber]}
              </TableCell>
            ))}
          </TableRow>
        ))}
        <TableRow>
          <TableCell
            className={clsx(classes.footer, 'olimpic-answer-cell')}
            align="left"
          >
            Ans.
          </TableCell>
          {data.data.map((sample, keyFooter) => (
            <TableCell
              className={clsx(classes.footer, 'olimpic-answer-cell')}
              check={check ? 'true' : 'false'}
              valid={validate({
                dataIndex: index,
                sampleIndex: keyFooter,
                state,
                args: data.data[keyFooter],
                params: data.params,
                direct: 'col',
                check,
              })}
            >
              <TextField
                onChange={onChange}
                onFocus={e => {
                  onFocus(keyFooter, e);
                }}
                onBlur={() => {
                  onBlur();
                }}
                disabled={check}
                name={`col_${keyFooter}`}
                style={{ backgroundColor: '#fff' }}
                autoFocus={keyFooter === 0 && index === 0}
                InputProps={{
                  autoComplete: 'off',
                }}
              />
              {check && (
                <div className={`${classes.answer} olimpic-answer-value`}>
                  {getAnswer(
                    data.data[keyFooter],
                    data.params.type,
                    state,
                    index,
                    keyFooter,
                    'col'
                  )}
                </div>
              )}
            </TableCell>
          ))}
        </TableRow>
      </TableBody>
    </StyledTable>
  );
};

TableSum.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  check: PropTypes.bool.isRequired,
  certificationType: PropTypes.string.isRequired,
  offset: PropTypes.number,
};

TableSum.defaultProps = {
  offset: undefined,
};

const TableFive = ({
  data,
  index,
  state,
  onChange,
  check,
  certificationType,
}) => {
  const classes = useStyles({ certificationType })();
  const [focusedCol, setFocusedCol] = useState();
  const onFocus = num => {
    setFocusedCol(num + 2);
  };
  const onBlur = () => {
    setFocusedCol(0);
  };
  return (
    <StyledTable
      className={classes.table}
      focusedCol={focusedCol}
      type={certificationType}
      onKeyDown={handleEnter}
    >
      <TableHead>
        <TableRow>
          <TableCell
            className={clsx(classes.head, 'olimpic-number-cell')}
            align="left"
          >
            No.
          </TableCell>
          {data.data.map((sample, keyHead) => (
            <TableCell className={clsx(classes.head, 'olimpic-number-cell')}>
              {size * index + (keyHead + 1)}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {data.data[0].map((n, keyNumber) => (
          <TableRow key={`${keyNumber}`}>
            <TableCell align="center">{keyNumber + 1}</TableCell>
            {data.data.map((s, keySample) => (
              <TableCell key={`${keySample}`} className={classes.body}>
                {data.data[keySample][keyNumber]}
              </TableCell>
            ))}
          </TableRow>
        ))}
        <TableRow>
          <TableCell
            className={clsx(classes.footer, 'olimpic-answer-cell')}
            align="left"
          >
            Ans.
          </TableCell>
          {data.data.map((sample, keyFooter) => (
            <TableCell
              className={clsx(classes.footer, 'olimpic-answer-cell')}
              check={check ? 'true' : 'false'}
              valid={validate({
                dataIndex: index,
                sampleIndex: keyFooter,
                state,
                args: data.data[keyFooter],
                params: data.params,
                direct: 'col',
                check,
              })}
            >
              <TextField
                onChange={onChange}
                onFocus={() => {
                  onFocus(keyFooter);
                }}
                onBlur={() => {
                  onBlur();
                }}
                disabled={check}
                name={`col_${keyFooter}`}
                style={{ backgroundColor: '#fff' }}
                autoFocus={keyFooter === 0 && index === 0}
                InputProps={{
                  autoComplete: 'off',
                }}
              />
              {check && (
                <div className={`${classes.answer} olimpic-answer-value`}>
                  {getAnswer(
                    data.data[keyFooter],
                    data.params.type,
                    state,
                    index,
                    keyFooter,
                    'col'
                  )}
                </div>
              )}
            </TableCell>
          ))}
        </TableRow>
      </TableBody>
    </StyledTable>
  );
};

TableFive.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  check: PropTypes.bool.isRequired,
  certificationType: PropTypes.string.isRequired,
};

const TableCard = ({
  data,
  index,
  state,
  onChange,
  check,
  certificationType,
}) => {
  const classes = useStyles({ certificationType })();
  return (
    <StyledTable
      className={classes.table}
      type={certificationType}
      onKeyDown={handleEnter}
    >
      <TableHead>
        <TableRow>
          <TableCell
            className={clsx(classes.head, 'olimpic-number-cell')}
            align="left"
          >
            №
          </TableCell>
          {data.data.map((sample, keyHead) => (
            <TableCell className={clsx(classes.head, 'olimpic-number-cell')}>
              {size * index + (keyHead + 1)}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {data.data[0].map((n, keyNumber) => (
          <TableRow key={`${keyNumber}`}>
            <TableCell
              className={clsx(classes.head, 'olimpic-number-cell')}
              align="left"
            >
              {keyNumber + 1}
            </TableCell>
            {data.data.map((s, keySample) => (
              <TableCell
                key={`${keySample}`}
                className={classes.body}
                style={{ padding: 0 }}
              >
                <VirtualAbacus
                  abacus={fillingValues(
                    data.data[keySample][keyNumber],
                    String(data.data[0]).length
                  )}
                />
              </TableCell>
            ))}
          </TableRow>
        ))}
        <TableRow>
          <TableCell
            className={clsx(classes.footer, 'olimpic-answer-cell')}
            align="left"
          >
            Ans.
          </TableCell>
          {data.data.map((sample, keyFooter) => (
            <TableCell
              className={clsx(classes.footer, 'olimpic-answer-cell')}
              check={check ? 'true' : 'false'}
              valid={validate({
                dataIndex: index,
                sampleIndex: keyFooter,
                state,
                args: data.data[keyFooter],
                params: data.params,
                direct: 'col',
                check,
              })}
            >
              <TextField
                onChange={onChange}
                disabled={check}
                name={`col_${keyFooter}`}
                style={{ backgroundColor: '#fff' }}
                autoFocus={keyFooter === 0 && index === 0}
                InputProps={{
                  autoComplete: 'off',
                }}
              />
              {check && (
                <div className={`${classes.answer} olimpic-answer-value`}>
                  {getAnswer(
                    data.data[keyFooter],
                    data.params.type,
                    state,
                    index,
                    keyFooter,
                    'col'
                  )}
                </div>
              )}
            </TableCell>
          ))}
        </TableRow>
      </TableBody>
    </StyledTable>
  );
};

TableCard.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  check: PropTypes.bool.isRequired,
  certificationType: PropTypes.string.isRequired,
};

const TableSumCrosswise = ({
  data,
  index,
  state,
  onChange,
  check,
  certificationType,
}) => {
  const classes = useStyles({ certificationType })();
  const [focusedCol, setFocusedCol] = useState();
  const [focusedRow, setFocusedRow] = useState();
  const onFocusCol = num => {
    setFocusedCol(num + 2);
  };
  const onBlurCol = () => {
    setFocusedCol(0);
  };
  const onFocusRow = num => {
    setFocusedRow(num + 1);
  };
  const onBlurRow = () => {
    setFocusedRow(0);
  };
  return (
    <StyledTable
      className={classes.table}
      focusedCol={focusedCol}
      focusedRow={focusedRow}
      type={certificationType}
      onKeyDown={handleEnter}
    >
      <TableHead>
        <TableRow>
          <TableCell
            className={clsx(classes.head, 'olimpic-number-cell')}
            align="left"
          >
            №
          </TableCell>
          {data.data.map((sample, keyHead) => (
            <TableCell className={clsx(classes.head, 'olimpic-number-cell')}>
              {size * index + (keyHead + 1)}
            </TableCell>
          ))}
          <TableCell
            className={clsx(classes.head, 'olimpic-number-cell')}
            align="left"
          >
            =
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.data[0].map((n, keyNumber) => (
          <TableRow key={`${keyNumber}`}>
            <TableCell className={classes.first} align="left">
              {keyNumber + 1}
            </TableCell>
            {data.data.map((s, keySample) => (
              <TableCell key={`${keySample}`} className={classes.body}>
                {data.data[keySample][keyNumber]}
              </TableCell>
            ))}
            <TableCell
              className={clsx(classes.footer, 'olimpic-answer-cell')}
              scope="withBg"
              check={check ? 'true' : 'false'}
              valid={validate({
                dataIndex: index,
                sampleIndex: keyNumber,
                state,
                args: getRowData(data.data, [keyNumber]),
                params: data.params,
                direct: 'row',
                check,
              })}
            >
              <TextField
                onChange={onChange}
                onFocus={() => {
                  onFocusRow(keyNumber);
                }}
                onBlur={() => {
                  onBlurRow();
                }}
                disabled={check}
                name={`row_${keyNumber}`}
                style={{ backgroundColor: '#fff' }}
                InputProps={{
                  autoComplete: 'off',
                }}
              />
              {check && (
                <div className={`${classes.answer} olimpic-answer-value`}>
                  {getAnswer(
                    getRowData(data.data, [keyNumber]),
                    data.params.type,
                    state,
                    index,
                    keyNumber,
                    'row'
                  )}
                </div>
              )}
            </TableCell>
          </TableRow>
        ))}
        <TableRow>
          <TableCell
            className={clsx(classes.footer, 'olimpic-answer-cell')}
            align="left"
          >
            Ans.
          </TableCell>
          {data.data.map((sample, keyFooter) => (
            <TableCell
              className={clsx(classes.footer, 'olimpic-answer-cell')}
              check={check ? 'true' : 'false'}
              valid={validate({
                dataIndex: index,
                sampleIndex: keyFooter,
                state,
                args: data.data[keyFooter],
                params: data.params,
                direct: 'col',
                check,
              })}
            >
              <TextField
                onChange={onChange}
                onFocus={() => {
                  onFocusCol(keyFooter);
                }}
                onBlur={() => {
                  onBlurCol();
                }}
                disabled={check}
                name={`col_${keyFooter}`}
                style={{ backgroundColor: '#fff' }}
                InputProps={{
                  autoComplete: 'off',
                }}
              />
              {check && certificationType === 'uamap' && (
                <div className={classes.answer}>
                  {getAnswer(
                    data.data[keyFooter],
                    data.params.type,
                    state,
                    index,
                    keyFooter,
                    'col'
                  )}
                </div>
              )}
            </TableCell>
          ))}
          <TableCell
            className={clsx(classes.footer, 'olimpic-answer-cell')}
            scope="withBg"
            check={check ? 'true' : 'false'}
            valid={validate({
              dataIndex: index,
              sampleIndex: index,
              state,
              args: data.data,
              params: data.params,
              direct: 'angle',
              check,
            })}
          >
            <TextField
              onChange={onChange}
              onFocus={() => {
                onFocusCol(data.data.length);
              }}
              onBlur={() => {
                onBlurCol();
              }}
              disabled={check}
              name="angle"
              style={{ backgroundColor: '#fff' }}
              InputProps={{
                autoComplete: 'off',
              }}
            />
            {check && (
              <div className={classes.answer}>
                {getAnswer(
                  data.data,
                  data.params.type,
                  state,
                  index,
                  index,
                  'angle'
                )}
              </div>
            )}
          </TableCell>
        </TableRow>
      </TableBody>
    </StyledTable>
  );
};

TableSumCrosswise.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  check: PropTypes.bool.isRequired,
  certificationType: PropTypes.string.isRequired,
};

const TableMultiplicationAndDivision = ({
  data,
  index,
  state,
  onChange,
  check,
  certificationType,
  offset,
}) => {
  const classes = useStyles({ certificationType })();
  return (
    <StyledTable
      className={classes.table}
      type={certificationType}
      onKeyDown={handleEnter}
    >
      <TableBody>
        {data.data.map((n, keyNumber) => (
          <TableRow key={`${keyNumber}`}>
            <TableCell
              key="0"
              className={clsx(classes.head, 'olimpic-number-cell')}
              align="left"
            >
              {offset + keyNumber + 1}
            </TableCell>
            <TableCell
              key="1"
              className={classes.body}
              align="right"
              style={{ whiteSpace: 'nowrap' }}
            >
              <span translate="no">
                {formatMathSample(data.data[keyNumber], data.params.type)}
              </span>
            </TableCell>
            <TableCell
              key="2"
              className={clsx(classes.footer, 'olimpic-answer-cell')}
              check={check ? 'true' : 'false'}
              align="left"
              valid={validate({
                dataIndex: index,
                sampleIndex: keyNumber,
                state,
                args: data.data[keyNumber],
                params: data.params,
                direct: 'row',
                check,
              })}
            >
              <Flex>
                <TextField
                  onChange={onChange}
                  disabled={check}
                  name={`row_${keyNumber}`}
                  autoFocus={keyNumber === 0 && index === 0}
                  style={{ backgroundColor: '#fff' }}
                  InputProps={{
                    autoComplete: 'off',
                  }}
                />
                {check && (
                  <div className={`${classes.answer} olimpic-answer-value`}>
                    {getAnswer(
                      data.data[keyNumber],
                      data.params.type,
                      state,
                      index,
                      keyNumber,
                      'row'
                    )}
                  </div>
                )}
              </Flex>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </StyledTable>
  );
};

TableMultiplicationAndDivision.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  check: PropTypes.bool.isRequired,
  certificationType: PropTypes.string.isRequired,
  offset: PropTypes.number.isRequired,
};

const TableBlock = ({ data, index, state, onChange, check, type, offset }) => {
  let component = <div>1</div>;
  const [certificationType, setCertificationType] = useState('sama');

  useEffect(() => {
    switch (type) {
      case 'abacus':
      case 'mental':
        setCertificationType('sama');
        break;
      default:
        setCertificationType('uamap');
        break;
    }
  }, [type]);

  if (data.params) {
    if (data.params.type === 'sum') {
      component = (
        <TableSum
          data={data}
          index={index}
          state={state}
          onChange={onChange}
          check={check}
          certificationType={certificationType}
          offset={offset}
        />
      );
    }
    if (['five', 'ten'].includes(data.params.type)) {
      component = (
        <TableFive
          data={data}
          index={index}
          state={state}
          onChange={onChange}
          check={check}
          certificationType={certificationType}
        />
      );
    }
    if (data.params.type === 'card') {
      component = (
        <TableCard
          data={data}
          index={index}
          state={state}
          onChange={onChange}
          check={check}
          certificationType={certificationType}
        />
      );
    }
    if (data.params.type === 'sumCrosswise') {
      component = (
        <TableSumCrosswise
          data={data}
          index={index}
          state={state}
          onChange={onChange}
          check={check}
          certificationType={certificationType}
        />
      );
    }
    if (['multiplication', 'division'].includes(data.params.type)) {
      component = (
        <TableMultiplicationAndDivision
          data={data}
          index={index}
          state={state}
          onChange={onChange}
          check={check}
          certificationType={certificationType}
          offset={offset}
        />
      );
    }
  }

  return <div style={{ pageBreakInside: 'avoid' }}>{component}</div>;
};

TableBlock.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  state: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  check: PropTypes.bool.isRequired,
  offset: PropTypes.number.isRequired,
};

const ResultComponent = ({
  view,
  settings,
  result,
  saveResult,
  requests,
  olimp,
  handleRepeat,
  id,
  smgl,
}) => {
  const classes = useStyles({})();
  const heads = settings.params;

  const [link, setLink] = useState('');

  const getNextLink = () => {
    if (view === 'print' && smgl) return '/olimpic/pamaprint';
    if (view === 'print') return '/olimpic/print';
    return '/olimpic/about';
  };

  const nextTestLink = getNextLink();

  const handleChange = event => {
    setLink(event.target.value);
  };

  const handleSave = () => {
    saveResult(id, view, { result, link, params: settings.params });
  };

  const request = requests[REQUEST_SAVE_OLIMPIC_RESULT];

  useEffect(() => {
    // if (view === 'simulate') {
    handleSave();
    // }
  }, []);

  return (
    <div>
      {request && (
        <div className="olimpic-result-success-block">
          {request.loading && <Loading />}
          {view !== 'print' && request.error && (
            <FormError>
              <FormattedMessage
                id={request.errorMessage}
                defaultMessage={request.errorMessage}
              />
            </FormError>
          )}
          {view !== 'print' && request.success && (
            <FormSuccess>
              <FormattedMessage
                id="OLIMPIC_SUCCESS_RESULT"
                defaultMessage="OLIMPIC_SUCCESS_RESULT"
              />
            </FormSuccess>
          )}
        </div>
      )}
      <Table className={clsx(classes.table, 'olimpic-result-table')}>
        <TableHead>
          <TableRow>
            {Object.entries(result).map(([index]) => {
              const head = heads.find(item => item.id === index);
              return (
                <StyledTableCell
                  key={index}
                  align="center"
                  className="olimpic-result-head"
                >
                  <FormattedMessage
                    id={head.title}
                    defaultMessage={head.title}
                  />
                </StyledTableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody className="olimpic-result-body">
          <StyledTableRow>
            {Object.entries(result).map(([index, value]) => (
              <StyledTableCell key={index} align="center">
                {value}
              </StyledTableCell>
            ))}
          </StyledTableRow>
        </TableBody>
      </Table>
      {view === 'exam' ? (
        <Box>
          <Box mb={4}>
            <SagnificantText>
              <FormattedMessage id="OLIMPIC_CONGRATS" defaultMessage="" />
            </SagnificantText>
          </Box>

          {olimp &&
            olimp.participant &&
            olimp.participant.olimpic &&
            olimp.participant.olimpic.end_video !== '' &&
            olimp.participant.olimpic.end_video != null && (
              <Box mb={4}>
                <iframe
                  width="560"
                  height="315"
                  src={olimp.participant.olimpic.end_video}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </Box>
            )}

          <Flex flexWrap="wrap">
            <TextField
              id="outlined-basic"
              size="small"
              onChange={handleChange}
              label={
                <FormattedMessage id="LINK_BY_VIDEO" defaultMessage="Link" />
              }
              variant="outlined"
              style={{ margin: '0 60px 10px 0', width: 250 }}
            />
            <Button variant="contained" color="primary" onClick={handleSave}>
              <FormattedMessage id="SAVE_LINK" defaultMessage="Save Link" />
            </Button>
          </Flex>
          <p>
            <FormattedMessage
              id="LINK_NOTICE"
              defaultMessage="The link can be attached later on the Olympiad tab"
            />
          </p>
        </Box>
      ) : (
        <Grid container justifyContent="center">
          <Button
            className={classes.button}
            color="primary"
            variant="contained"
            onClick={handleRepeat}
          >
            <Link to={nextTestLink}>
              <FormattedMessage id="NEXT_TEST" defaultMessage="Repeat" />
            </Link>
          </Button>
        </Grid>
      )}
    </div>
  );
};

ResultComponent.propTypes = {
  view: PropTypes.string.isRequired,
  olimp: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  result: PropTypes.object.isRequired,
  saveResult: PropTypes.func.isRequired,
  handleRepeat: PropTypes.func,
  id: PropTypes.string,
  smgl: PropTypes.bool,
};

ResultComponent.defaultProps = {
  handleRepeat: () => {},
  id: '',
  smgl: false,
};

const mapStateToPropsResult = state => ({
  requests: state.requests,
  olimp: state.olimpic,
});

ResultComponent.propTypes = {
  requests: PropTypes.object.isRequired,
};

export const Result = connect(mapStateToPropsResult)(ResultComponent);

const AnswerSheet = ({ samples, offsets }) => {
  const allAnswers = [];

  const isTieBreak =
    samples.length === 4 && samples.every(s => s.customOffset !== undefined);

  if (isTieBreak) {
    const sumBlock1 = samples[0];
    const multiBlock = samples[1];
    const sumBlock2 = samples[2];
    const divBlock = samples[3];
    [...sumBlock1.data, ...sumBlock2.data].forEach((sample, i) => {
      const answer = getAnswer(sample, sumBlock1.params.type, {}, 0, 0, 'col');
      allAnswers.push({ num: i + 1, answer });
    });
    multiBlock.data.forEach((sample, i) => {
      const answer = getAnswer(sample, multiBlock.params.type, {}, 0, 0, 'col');
      allAnswers.push({ num: i + 1, answer });
    });
    divBlock.data.forEach((sample, i) => {
      const answer = getAnswer(sample, divBlock.params.type, {}, 0, 0, 'col');
      allAnswers.push({ num: i + 1, answer });
    });
  } else {
    // остальные этапы
    samples.forEach((sampleData, blockIndex) => {
      const { data, params, customOffset } = sampleData;

      const startNum =
        customOffset !== undefined
          ? customOffset + 1
          : offsets && offsets[blockIndex] !== undefined
          ? offsets[blockIndex] + 1
          : 1;

      data.forEach((sample, i) => {
        const answer = getAnswer(sample, params.type, {}, 0, 0, 'col');
        allAnswers.push({ num: startNum + i, answer });
      });
    });
  }

  return (
    <div style={{ fontSize: '14px', lineHeight: '1.5' }}>
      {allAnswers.map((item, index) => (
        <span
          key={index}
          style={{
            marginRight: '12px',
            whiteSpace: 'nowrap',
            display: 'inline-block',
          }}
        >
          <strong>{item.num}. </strong>
          {item.answer}
        </span>
      ))}
    </div>
  );
};

AnswerSheet.propTypes = {
  samples: PropTypes.array.isRequired,
  offsets: PropTypes.array,
};

AnswerSheet.defaultProps = {
  offsets: undefined,
};

const RunExam = React.forwardRef((props, ref) => {
  const {
    loadData,
    loadStageData,
    checkParticipation,
    requests,
    olimp,
    view,
    settings,
    handlePrint,
    saveResult,
    clearRequest,
    handleRepeat,
    className,
    id,
    isOfficialMode = false,
    smgl,
  } = props;
  const { list } = olimp;
  const classes = useStyles({})();

  const {
    olimpic: {
      timer: { start, end },
    },
    // timerPeriod,
  } = useOlimpicState();

  const { onStart, onStop, onReset, updateProp, onEnd } = useOlimpicActions();

  const [activeStep, setActiveStep] = useState(0);
  const [activeData, setActiveData] = useState({
    id: 'MIN',
    level: 'MIN',
    title: 'MIN',
    desc: 'MIN',
    time: 3,
  });

  useEffect(() => {
    checkParticipation();
  }, []);

  useEffect(() => {
    if (settings.params) {
      setActiveData(settings.params[activeStep]);
    }
  }, [activeStep, settings.type, settings.level]);

  const [state, setState] = useState({});
  const [result, setResult] = useState({});
  const [scope, setScope] = useState(0);
  const [check, setCheck] = useState(false);

  const [isPrintAllMode, setIsPrintAllMode] = useState(false);
  const [allStagesData, setAllStagesData] = useState(null);
  const [isLoadingAll, setIsLoadingAll] = useState(false);

  const [steps, setSteps] = useState([]);
  useEffect(() => {
    if (settings.params) {
      setSteps(settings.params.map(item => [item.title, item.level, item.id]));
    }
  }, [settings.level, settings.type]);

  const [numbersList, setNumbersList] = useState([]);

  // для нумерации отображения примеров
  const [offsetTable, setOffsetTable] = useState([]);

  useEffect(() => {
    if (numbersList.length === 0) return;

    const lengths = numbersList.map(item => item.data.length);
    const cumulative = [0];

    for (let i = 0; i < lengths.length - 1; i += 1) {
      cumulative.push(cumulative[i] + lengths[i]);
    }

    setOffsetTable(cumulative);
  }, [numbersList]);

  const handleNext = () => {
    setIsPrintAllMode(false);
    setAllStagesData(null);
    setActiveStep(activeStep + 1);
    setScope(0);
    setState({});
    // onStop();
    onReset();
    setNumbersList([]);
    setCheck(false);
  };

  // передаем если включены примеры присланные для дня олимпиады Pama
  const useOfficialExamples =
    view === 'exam' && view !== 'print' && isOfficialMode;

  useEffect(() => {
    if (start) {
      const payload = {
        simulator: settings.type,
        level: activeData.differentLevel || settings.level,
        type: activeData.type,
        step: activeData.id,
      };

      if (useOfficialExamples) {
        payload.official_mode = 1;
      }

      if (activeData.printSamples) {
        payload.limit = activeData.printSamples;
      }

      loadData(payload);
    }
  }, [start]);

  const handleStart = () => {
    setIsPrintAllMode(false);
    setAllStagesData(null);
    setScope(0);
    onStart();
  };

  const handlePrintAllStages = async () => {
    setIsLoadingAll(true);
    const stagesToLoad = settings.params.filter(s => s.type !== 'RESULT');
    try {
      const allData = await Promise.all(
        stagesToLoad.map(async stageParams => {
          const payload = {
            simulator: settings.type,
            level: stageParams.differentLevel || settings.level,
            type: stageParams.type,
            step: stageParams.id,
          };
          if (stageParams.printSamples) {
            payload.limit = stageParams.printSamples;
          }
          if (useOfficialExamples) {
            payload.official_mode = 1;
          }
          const stageResult = await loadStageData(payload, stageParams.id);
          if (stageResult?.type !== 'SUCCESS') {
            throw new Error(`Failed to load stage ${stageParams.id}`);
          }
          const rawData = stageResult.payload.data;

          let nextNumbers = [];
          const len = rawData?.length || 0;

          // PAMA TIE-BREAK CUSTOM LAYOUT (Сетка 2x2)
          if (smgl && view === 'print' && stageParams.id === 'MixA') {
            let sumData = [];
            let multiData = [];
            let divData = [];
            for (let i = 0; i < len; i += 1) {
              const samples = rawData[i];
              if (samples.params) {
                if (samples.params.type === 'sum') {
                  sumData = [...sumData, ...samples.data];
                } else if (samples.params.type === 'multiplication') {
                  multiData = [...multiData, ...samples.data].slice(0, 10);
                } else if (samples.params.type === 'division') {
                  divData = [...divData, ...samples.data].slice(0, 10);
                }
              }
            }
            const sumBlock1 = sumData.slice(0, 5);
            const sumBlock2 = sumData.slice(5, 10);
            nextNumbers = [
              {
                data: sumBlock1,
                params: { type: 'sum', size: 10 },
                customOffset: 0,
              },
              {
                data: multiData,
                params: { type: 'multiplication', size: 5 },
                customOffset: 0,
              },
              {
                data: sumBlock2,
                params: { type: 'sum', size: 10 },
                customOffset: 5,
              },
              {
                data: divData,
                params: { type: 'division', size: 5 },
                customOffset: 0,
              },
            ];
          } else {
            for (let i = 0; i < len; i += 1) {
              const samples = rawData[i];
              let samplesData = samples.data;
              if (smgl && view === 'print' && stageParams.printSamples) {
                samplesData = samplesData.slice(0, stageParams.printSamples);
              }
              let divideSamples = [samplesData];
              if (samples.params) {
                divideSamples = samplesData.reduce((acc, item, key) => {
                  const { length } = samplesData;
                  const index = Math.floor(
                    key /
                      // eslint-disable-next-line no-nested-ternary
                      (['multiplication', 'division'].includes(
                        samples.params.type
                      )
                        ? length /
                          {
                            true: 2,
                            [!(length % 15)]: length / 15,
                            [!(length % 20)]: length / 20,
                          }.true
                        : size)
                  );
                  if (!acc[index]) {
                    acc[index] = [];
                  }
                  acc[index].push(item);
                  return acc;
                }, []);
              }
              nextNumbers = [
                ...nextNumbers,
                ...divideSamples.map(rowData => ({
                  data: rowData,
                  params: samples.params,
                })),
              ];
            }
          }

          const lengths = nextNumbers.map(item => item.data.length);
          const cumulative = [0];
          for (let i = 0; i < lengths.length - 1; i += 1) {
            cumulative.push(cumulative[i] + lengths[i]);
          }

          return {
            stageInfo: stageParams,
            samples: nextNumbers,
            offsets: cumulative,
          };
        })
      );
      setAllStagesData(allData);
      setIsPrintAllMode(true);
      setTimeout(() => handlePrint(), 500);
    } catch (error) {
      console.error('[PRINT_ALL] Error loading stages:', error);
    } finally {
      setIsLoadingAll(false);
    }
  };
  const handleChange = (event, params, index) => {
    const nextState = {
      ...state,
      [index]: {
        ...(state[index] ? state[index] : {}),
        [event.target.name]: event.target.value,
      },
    };

    setState(nextState);
  };

  const handleCheck = () => {
    let scopeTotal = 0;
    for (let i = 0; i < numbersList.length; i += 1) {
      const samples = numbersList[i];
      if (samples.params && samples.params.type === 'sum') {
        for (let j = 0; j < samples.data.length; j += 1) {
          if (
            equalfn(samples.data[j], samples.params.type, state, i, j, 'col')
          ) {
            scopeTotal += samples.params.size;
          }
        }
      }
      if (samples.params && samples.params.type === 'five') {
        for (let j = 0; j < samples.data.length; j += 1) {
          if (
            equalfn(samples.data[j], samples.params.type, state, i, j, 'col')
          ) {
            scopeTotal += samples.params.size;
          }
        }
      }
      if (samples.params && samples.params.type === 'ten') {
        for (let j = 0; j < samples.data.length; j += 1) {
          if (
            equalfn(samples.data[j], samples.params.type, state, i, j, 'col')
          ) {
            scopeTotal += samples.params.size;
          }
        }
      }
      if (samples.params && samples.params.type === 'card') {
        for (let j = 0; j < samples.data.length; j += 1) {
          if (
            equalfn(samples.data[j], samples.params.type, state, i, j, 'col')
          ) {
            scopeTotal += samples.params.size;
          }
        }
      }
      if (samples.params && samples.params.type === 'sumCrosswise') {
        for (let j = 0; j < samples.data.length; j += 1) {
          if (
            equalfn(samples.data[j], samples.params.type, state, i, j, 'col')
          ) {
            scopeTotal += samples.params.size;
          }
        }
        for (let j = 0; j < samples.data[0].length; j += 1) {
          if (
            equalfn(
              getRowData(samples.data, j),
              samples.params.type,
              state,
              i,
              j,
              'row'
            )
          ) {
            scopeTotal += 5;
          }
        }
        if (equalfn(samples.data, samples.params.type, state, i, i, 'angle')) {
          scopeTotal += samples.params.size;
        }
      }
      if (
        samples.params &&
        ['multiplication', 'division'].includes(samples.params.type)
      ) {
        for (let j = 0; j < samples.data.length; j += 1) {
          // const delta =
          //   settings.type === 'teacher' && +settings.level === 3 ? 1 : 5;
          if (
            equalfn(samples.data[j], samples.params.type, state, i, j, 'row')
          ) {
            scopeTotal += samples.params.size;
          }
        }
      }
    }
    setResult(prevResult => ({ ...prevResult, [activeData.id]: scopeTotal }));
    setCheck(true);
    onStop();
    setScope(scopeTotal);
  };

  useEffect(() => {
    if (end) {
      handleCheck();
    }
  }, [end]);

  useEffect(() => {
    if (start) {
      let nextNumbers = [];

      const len = list?.length || 0;

      // PAMA TIE-BREAK CUSTOM LAYOUT (Сетка 2x2)
      if (smgl && view === 'print' && activeData.id === 'MixA') {
        let sumData = [];
        let multiData = [];
        let divData = [];

        // Собираем данные по типам из всех элементов list
        for (let i = 0; i < len; i += 1) {
          const samples = list[i];
          if (samples.params) {
            if (samples.params.type === 'sum') {
              sumData = [...sumData, ...samples.data];
            } else if (samples.params.type === 'multiplication') {
              multiData = [...multiData, ...samples.data].slice(0, 10);
            } else if (samples.params.type === 'division') {
              divData = [...divData, ...samples.data].slice(0, 10);
            }
          }
        }

        // Разбиваем sum на 2 блока по 5 столбцов
        const sumBlock1 = sumData.slice(0, 5);
        const sumBlock2 = sumData.slice(5, 10);

        // [Sum1 (Top-Left), Multi (Top-Right), Sum2 (Bottom-Left), Div (Bottom-Right)]
        setNumbersList([
          {
            data: sumBlock1,
            params: { type: 'sum', size: 10 },
            customOffset: 0,
          },
          {
            data: multiData,
            params: { type: 'multiplication', size: 5 },
            customOffset: 0,
          },
          {
            data: sumBlock2,
            params: { type: 'sum', size: 10 },
            customOffset: 5,
          },
          {
            data: divData,
            params: { type: 'division', size: 5 },
            customOffset: 0,
          },
        ]);
        return; // Пропускаем стандартную логику divideSamples
      }

      for (let i = 0; i < len; i += 1) {
        const samples = list[i];
        // Обрезаем данные для PamaPrint
        let samplesData = samples.data;
        if (smgl && view === 'print' && activeData.printSamples) {
          samplesData = samplesData.slice(0, activeData.printSamples);
        }

        let divideSamples = [samplesData];
        if (samples.params) {
          divideSamples = samplesData.reduce((acc, item, key) => {
            const { length } = samplesData;
            const index = Math.floor(
              key /
                // eslint-disable-next-line no-nested-ternary
                (['multiplication', 'division'].includes(samples.params.type)
                  ? length /
                    {
                      true: 2,
                      [!(length % 15)]: length / 15,
                      [!(length % 20)]: length / 20,
                    }.true
                  : size)
            );
            if (!acc[index]) {
              acc[index] = [];
            }
            acc[index].push(item);
            return acc;
          }, []);
        }
        nextNumbers = [
          ...nextNumbers,
          ...divideSamples.map(rowData => ({
            data: rowData,
            params: samples.params,
          })),
        ];
      }
      setNumbersList(nextNumbers);
    }
  }, [list, start]);

  useEffect(() => {
    updateProp('timerPeriod', activeData.time);
  }, [activeData]);

  const handleSaveFail = () => {
    saveResult(id, view, {
      result,
      params: settings.params,
      end_at: new Date(),
      meta: { fail: 'true', type: 'reload' },
    });
  };

  const history = useHistory();

  const saveRequest = requests[REQUEST_SAVE_OLIMPIC_RESULT];

  useEffect(() => {
    return () => {
      clearRequest(REQUEST_SAVE_OLIMPIC_RESULT);
    };
  }, []);

  useEffect(() => {
    window.addEventListener('beforeunload', handleSaveFail);

    return async () => {
      window.removeEventListener('beforeunload', handleSaveFail);

      if (
        view === 'exam' &&
        !history.location.pathname.includes('run/exam') &&
        steps.length > 0 &&
        !saveRequest
      ) {
        saveResult(id, view, {
          result,
          params: settings.params,
          end_at: new Date(),
          meta: { fail: 'true', type: 'navigate' },
        });
      }
    };
  }, [result, activeStep, saveRequest]);

  const currentOrientation = activeData?.orientation || 'portrait';

  const response = requests[REQUEST_OLIMPIC_LIST];

  return (
    <div ref={ref} className={className}>
      {view === 'print' && (
        <style>
          {`
          @media print {
            @page {
              size: ${currentOrientation};
              margin: 0.2in;
            }
          }
        `}
        </style>
      )}
      <WrapperStyled
        type={['abacus', 'mental'].includes(settings.type) ? 'sama' : 'uamap'}
        smgl={smgl}
      >
        {start && response?.success && view !== 'print' && (
          <Timer
            time={activeData.time * 60}
            start={start}
            onEnd={onEnd}
            className="olimpic_timer"
          />
        )}
        {response?.success && <Gamification data={response.gamification} />}
        {response?.loading && <Loading />}
        <StyledPanel
          $smgl={smgl}
          $view={view}
          $hideInPrintAll={isPrintAllMode}
          style={
            view === 'print' &&
            start &&
            process.env.NODE_ENV === 'development' &&
            !smgl
              ? {
                  background: `url(${UamapBG})`,
                  backgroundSize: '60% auto',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                }
              : {}
          }
        >
          <Box>
            <Box mb={view === 'print' ? 1 : 4} className="step-info-title">
              <span>
                <SagnificantText>
                  {/* eslint-disable-next-line no-nested-ternary */}
                  {activeStep === steps.length - 1 ? (
                    <span>
                      <FormattedMessage id="RESULT" defaultMessage="Result" />
                    </span>
                  ) : smgl && view === 'print' ? (
                    // PAMA PRINT - кастомная шапка
                    <span translate="no">
                      {getPamaPrintTitle(activeData)} Group : {settings.name}
                      {'  '}
                      Time : {activeData.time} min{' '}
                      {activeData.type === 'Mix' ? (
                        // Для tie-break:
                        <>10 marks (+-) / 5 marks (x÷)</>
                      ) : (
                        // Для остальных этапов Pama
                        <>Each Q : {activeData.score || 10} marks</>
                      )}
                    </span>
                  ) : (
                    <span>
                      <span>
                        <FormattedMessage
                          id="CATEGORY"
                          defaultMessage="Category"
                        />
                      </span>
                      <span>: </span> <span>{settings.name}</span>
                      <span>, </span>
                      <span>
                        {' '}
                        {!smgl && (
                          <span>
                            {' '}
                            <span>
                              <FormattedMessage
                                id={`${activeData.type}${activeData.variant ||
                                  ''}`}
                              />
                            </span>{' '}
                            <span className="notranslate">
                              {activeData.short}
                            </span>
                            <span>, </span>
                          </span>
                        )}{' '}
                      </span>
                      <span>{activeData.samples}</span>{' '}
                      <span>
                        <FormattedMessage
                          id="OLIMPIC_SAMPLES_TITLE"
                          defaultMessage="samples"
                        />
                      </span>
                      <span>, </span>
                      <span>
                        <FormattedMessage id="TIME" defaultMessage="time" />
                      </span>
                      <span>: </span> <span>{activeData.time}</span>{' '}
                      <span>
                        <FormattedMessage id="min" defaultMessage="min" />
                      </span>
                      <span>, </span>
                      <span>
                        <FormattedMessage id="EACH_Q" defaultMessage="Each q" />
                      </span>
                      <span>: </span>
                      <span>{activeData.score}</span>{' '}
                      <span>
                        <FormattedMessage id="marks" defaultMessage="marks" />
                      </span>
                    </span>
                  )}
                </SagnificantText>
              </span>
            </Box>
            <div>
              {(view !== 'print' || smgl) && (
                <HideOnPrint>
                  <Stepper
                    nonLinear
                    activeStep={activeStep}
                    className={classes.root}
                  >
                    {steps.map(([title, , key]) => (
                      <Step key={key}>
                        <StepButton>
                          <FormattedMessage id={title} defaultMessage={title} />
                        </StepButton>
                      </Step>
                    ))}
                  </Stepper>
                </HideOnPrint>
              )}
              <HideOnPrint>
                {view === 'print' && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handlePrintAllStages}
                    disabled={isLoadingAll || start || check}
                    className={classes.button}
                  >
                    {isLoadingAll ? (
                      <FormattedMessage
                        id="LOADING"
                        defaultMessage="Loading..."
                      />
                    ) : (
                      <FormattedMessage
                        id="PRINT_ALL_STAGES"
                        defaultMessage="Print all stages"
                      />
                    )}
                  </Button>
                )}
              </HideOnPrint>
              {activeStep === steps.length - 1 ? (
                <Result
                  view={view}
                  settings={settings}
                  result={result}
                  handleRepeat={handleRepeat}
                  saveResult={saveResult}
                  id={id}
                  smgl={smgl}
                />
              ) : (
                <div>
                  <HideOnPrint>
                    <Grid
                      container
                      spacing={3}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Grid item>
                        <Button
                          onClick={handleStart}
                          className={classes.button}
                          color="primary"
                          variant="contained"
                          disabled={start || (!start && check)}
                        >
                          <span>
                            <FormattedMessage
                              id="START"
                              defaultMessage="START"
                            />
                          </span>
                        </Button>

                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleCheck}
                          className={classes.button}
                          disabled={!start && !check}
                        >
                          <span>
                            <FormattedMessage
                              id="CHECK"
                              defaultMessage="CHECK"
                            />
                          </span>
                        </Button>

                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleNext}
                          className={classes.button}
                          disabled={!check && view !== 'print'}
                        >
                          <span>
                            <FormattedMessage
                              id={
                                activeStep === steps.length - 2
                                  ? 'END'
                                  : 'NEXT_LEVEL'
                              }
                              defaultMessage="NEXT_LEVEL"
                            />
                          </span>
                        </Button>
                      </Grid>

                      <Grid item>
                        <Flex alignItems="center" gridGap={5} translate="no">
                          {(start || check) && view === 'print' && (
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.button}
                              onClick={handlePrint}
                            >
                              <span>
                                <FormattedMessage
                                  id="TO_PRINT"
                                  defaultMessage="TO_PRINT"
                                />
                              </span>
                            </Button>
                          )}
                          <span>
                            <FormattedMessage id="SCORE_O" />
                          </span>
                          <div
                            style={{
                              border: '2px solid rgb(37 39 51 / 21%)',
                              color: 'rgba(37, 39, 51, 0.5)',
                              borderRadius: '5px',
                              width: '42px',
                              lineHeight: '42px',
                              height: '42px',
                              textAlign: 'center',
                            }}
                          >
                            <span>{scope}</span>
                          </div>
                        </Flex>
                      </Grid>
                    </Grid>
                  </HideOnPrint>

                  {response?.success && (
                    <Flex flexWrap="wrap" justifyContent="center">
                      {numbersList.map((data, key) => {
                        const columnWidth = 1 / numbersList.length;

                        const isMathType = [
                          'multiplication',
                          'division',
                        ].includes(data.params.type);
                        const isSumType = data.params.type === 'sum';
                        let width = null;

                        if (isMathType) {
                          if (numbersList.length > 3) {
                            /* eslint-disable no-nested-ternary */
                            width =
                              view === 'print'
                                ? smgl
                                  ? 0.5
                                  : columnWidth
                                : ['100%', '100%', '50%', '50%'];
                          } else {
                            width =
                              view === 'print'
                                ? columnWidth
                                : ['100%', '100%', columnWidth, columnWidth];
                          }
                        } else if (
                          isSumType &&
                          smgl &&
                          view === 'print' &&
                          activeData.id === 'MixA'
                        ) {
                          // Для PamaPrint tie-break sum блоки занимают 50% ширины
                          width = 0.5;
                        }

                        const isPamaMath =
                          smgl && view === 'print' && isMathType;

                        const isTiebreakMath =
                          smgl &&
                          view === 'print' &&
                          activeData.id === 'MixA' &&
                          isMathType;

                        return (
                          <Box
                            minWidth={view === 'print' && !smgl ? 'auto' : 280}
                            w={width}
                            px={view === 'print' ? 0 : 1}
                            key={key}
                            className={
                              smgl && view === 'print'
                                ? `pama-print-block ${
                                    isPamaMath ? 'pama-print-math' : ''
                                  } ${
                                    isTiebreakMath ? 'pama-tiebreak-math' : ''
                                  }`
                                : ''
                            }
                          >
                            <TableBlock
                              data={data}
                              type={settings.type}
                              index={key}
                              state={state}
                              check={check}
                              onChange={event =>
                                handleChange(event, data.params, key)
                              }
                              offset={
                                data.customOffset !== undefined
                                  ? data.customOffset
                                  : offsetTable[key]
                              }
                            />
                          </Box>
                        );
                      })}
                    </Flex>
                  )}
                </div>
              )}
            </div>
          </Box>
        </StyledPanel>
        {/* ПЕЧАТЬ ВСЕ ВМЕСТЕ ЭТАПЫ */}
        {isPrintAllMode &&
          allStagesData &&
          (() => {
            const printAllContent = (
              <div className="print-all-stages-container">
                {allStagesData.map((stage, stageIndex) => {
                  return (
                    <div
                      key={stageIndex}
                      style={{
                        pageBreakAfter:
                          stageIndex < allStagesData.length - 1
                            ? 'always'
                            : 'auto',
                      }}
                    >
                      <Box mb={1} className="step-info-title">
                        <span>
                          <StageHeader
                            stageInfo={stage.stageInfo}
                            settings={settings}
                            smgl={smgl}
                            view="print"
                          />
                        </span>
                      </Box>

                      <Flex flexWrap="wrap" justifyContent="center">
                        {stage.samples.map((data, key) => {
                          const columnWidth = 1 / stage.samples.length;
                          const isMathType = [
                            'multiplication',
                            'division',
                          ].includes(data.params.type);
                          const isSumType = data.params.type === 'sum';
                          let width = null;

                          if (isMathType) {
                            if (stage.samples.length > 3) {
                              width = smgl ? 0.5 : columnWidth;
                            } else {
                              width = columnWidth;
                            }
                          } else if (
                            isSumType &&
                            smgl &&
                            stage.stageInfo.id === 'MixA'
                          ) {
                            width = 0.5;
                          }

                          const isPamaMath = smgl && isMathType;
                          const isTiebreakMath =
                            smgl && stage.stageInfo.id === 'MixA' && isMathType;

                          return (
                            <Box
                              key={key}
                              w={width}
                              px={0}
                              minWidth={
                                view === 'print' && !smgl ? 'auto' : 280
                              }
                              className={
                                smgl
                                  ? `pama-print-block ${
                                      isPamaMath ? 'pama-print-math' : ''
                                    } ${
                                      isTiebreakMath ? 'pama-tiebreak-math' : ''
                                    }`
                                  : ''
                              }
                            >
                              <TableBlock
                                data={data}
                                type={settings.type}
                                index={key}
                                state={{}}
                                check={false}
                                onChange={() => {}}
                                offset={
                                  data.customOffset !== undefined
                                    ? data.customOffset
                                    : stage.offsets[key]
                                }
                              />
                            </Box>
                          );
                        })}
                      </Flex>
                    </div>
                  );
                })}

                {/* Лист ответов */}
                <div style={{ pageBreakBefore: 'always' }}>
                  <h2 style={{ marginBottom: '5px' }}>
                    <FormattedMessage id="ANSWERS" defaultMessage="Answers" />{' '}
                    <FormattedMessage id="CATEGORY" defaultMessage="Category" />
                    : {settings.name}
                  </h2>
                  {allStagesData.map((stage, stageIndex) => (
                    <div
                      key={stageIndex}
                      style={{ marginBottom: '12px', pageBreakInside: 'avoid' }}
                    >
                      <Box
                        className="step-info-title"
                        style={{ fontSize: '14px' }}
                      >
                        <span>
                          <StageHeader
                            stageInfo={stage.stageInfo}
                            settings={settings}
                            smgl={smgl}
                            view="print"
                            compact
                          />
                        </span>
                      </Box>
                      <AnswerSheet
                        samples={stage.samples}
                        offsets={stage.offsets}
                      />
                    </div>
                  ))}
                </div>
              </div>
            );

            return smgl ? (
              <StyledPanel $smgl={smgl} $view="print" $hideInPrintAll={false}>
                {printAllContent}
              </StyledPanel>
            ) : (
              printAllContent
            );
          })()}
        {/* ПЕЧАТЬ ВСЕ ВМЕСТЕ ЭТАПЫ КОНЕЦ */}
      </WrapperStyled>
      {!smgl && <CenterIcon />}
    </div>
  );
});

const mapStateToProps = state => ({
  olimp: state.olimpic,
  requests: state.requests,
});

const mapDispatchToProps = dispatch => ({
  loadData(formData) {
    return dispatch(fetchList(formData));
  },
  checkParticipation() {
    dispatch(fetchParticipation());
  },
  saveResult(id, view, formData) {
    return dispatch(fetchSaveOlimpicResult(id, view, formData));
  },
  clearRequest(name) {
    dispatch(cleaRequest(name));
  },
  loadStageData(formData, stageId) {
    return dispatch(fetchOlimpicStageData(formData, stageId));
  },
});

RunExam.propTypes = {
  olimp: PropTypes.object.isRequired,
  requests: PropTypes.object.isRequired,
  loadData: PropTypes.func.isRequired,
  checkParticipation: PropTypes.func.isRequired,
  saveResult: PropTypes.func.isRequired,
  clearRequest: PropTypes.func.isRequired,
  view: PropTypes.string.isRequired,
  settings: PropTypes.object,
  handlePrint: PropTypes.func.isRequired,
  handleRepeat: PropTypes.func,
  className: PropTypes.string,
  id: PropTypes.string,
  smgl: PropTypes.bool,
  isOfficialMode: PropTypes.bool,
  loadStageData: PropTypes.func.isRequired,
};

RunExam.defaultProps = {
  handleRepeat: () => {},
  settings: {},
  className: '',
  id: '',
  smgl: false,
  isOfficialMode: false,
};

const RunExamComponent = connect(mapStateToProps, mapDispatchToProps)(RunExam);

export default React.forwardRef((props, ref) => (
  <div ref={ref}>
    <RunExamComponent {...props} />
  </div>
));
